import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class OrderService {
    baseUrl: string = 'Order.svc';
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
    delete(id) {        
        return this._ajaxService.GET(this.baseUrl + "/delete/" + id);        
    }
    select(id) {        
        return this._ajaxService.GET(this.baseUrl + "/select/"+id);        
    }
    all(pageIndex, pageSize, sortHeaderName, sortDirection, filterText, filterDateFrom, filterDateTo, filterOrderStatus, filterShipperOrdNo, distributorId, filterCountryId) {
        return this._ajaxService.GET(this.baseUrl + "/all/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterDateFrom + "/" + filterDateTo + "/" + filterOrderStatus + "/" +  filterShipperOrdNo + "/" + distributorId + "/"+ filterCountryId +"/" + filterText); 
    }
    selectCode(code) {
        return this._ajaxService.GET(this.baseUrl + "/selectCode/" + code);
    }
    orderCustomArticles(customOrderId: string) {
        return this._ajaxService.GET(this.baseUrl + "/orderCustomArticles/" + customOrderId);
    }
    orderCustomSelect(orderId: string){
         return this._ajaxService.GET(this.baseUrl + "/orderCustomSelect/" + orderId);
    }
    orderCustomSave(orderCustoms: any){
         return this._ajaxService.POST(this.baseUrl + "/orderCustomSave", JSON.stringify(orderCustoms));
    }
    saveDocument(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/saveDocument", dataToBePost);        
    }
    deleteDocument(id) {        
        return this._ajaxService.GET(this.baseUrl + "/deleteDocument/" + id);        
    }
    selectDocument(id) {        
        return this._ajaxService.GET(this.baseUrl + "/selectDocument/"+id);        
    }
    allDocument(orderId,pageIndex,pageSize,sortHeaderName,sortDirection,filterText) {        
        return this._ajaxService.GET(this.baseUrl + "/allDocument/" + orderId + "/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterText); 
    }
    distOrder(pageIndex, pageSize, sortHeaderName, sortDirection, filterText, filterDateFrom, filterDateTo, filterOrderStatus, filterShipperOrdNo, filterCountryId) {        
        return this._ajaxService.GET(this.baseUrl + "/distOrder/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterDateFrom + "/" + filterDateTo + "/" + filterOrderStatus + "/" +  filterShipperOrdNo + "/" + filterCountryId +"/" + filterText); 
    }
    selectOrderRemark(orderId){
        return this._ajaxService.GET(this.baseUrl + "/selectOrderRemark/"+ orderId); 
    }
    saveOrderRemark(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/saveOrderRemark", dataToBePost);        
    }
    isSORDNUMExists(shipperOrderNumber){
         return this._ajaxService.GET(this.baseUrl + "/IsSORDNUMExists/"+ shipperOrderNumber); 
    }
    getDistributors(){
        return this._ajaxService.GET(this.baseUrl + "/SelectDistributors"); 
    }
    summary(pageIndex, pageSize, sortHeaderName, sortDirection, filterText, filterDateFrom, filterDateTo, filterOrderStatus, filterShipperOrdNo, distributorId, filterCountryId) {
        return this._ajaxService.GET(this.baseUrl + "/summary/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterDateFrom + "/" + filterDateTo + "/" + filterOrderStatus + "/" +  filterShipperOrdNo + "/" + distributorId + "/"+ filterCountryId +"/" + filterText); 
    }
    distSummary(pageIndex, pageSize, sortHeaderName, sortDirection, filterText, filterDateFrom, filterDateTo, filterOrderStatus, filterShipperOrdNo, filterCountryId) {
        return this._ajaxService.GET(this.baseUrl + "/distSummary/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterDateFrom + "/" + filterDateTo + "/" + filterOrderStatus + "/" +  filterShipperOrdNo  + "/"+ filterCountryId +"/" + filterText); 
    }
}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/order.service.ts